<a
	target="_self"
	[class]="buttonClasses[buttonType()] + ' u-outline ' + customButtonClass() + ' layout-' + layout()"
	[ngClass]="{ 'is-disabled': isDisabled() }"
	[title]="title()"
	[cypressTag]="buttonCypressTag()"
	[routerLink]="isDisabled() ? null : link()"
	[queryParams]="linkQueryParams()"
	[queryParamsHandling]="linkQueryParamsHandling()"
	[cypressTag]="buttonCypressTag() || 'General.Input.Button'"
	(click)="handleButtonClick()"
>
	<ng-content />

	@if (icon()) {
		<vlaio-icon [icon]="icon()"></vlaio-icon>
	}
</a>
